<template>
  <div>
    <common-dialog
      ref="dialog"
      width="1200px"
      unit="商家信息"
      edit-title
      id-key="RecordId"
      :data="data"
      :get-data-func="api.info"
      :form-rules="rules"
      :save-func="api.save"
      @create-opened="onCreateOpened"
      @edit-opened="onEditOpened"
      :before-save="onBeforeSave"
      close-on-saved
      form-label-width="140px"
      @close-saved="$emit('close-saved')"
      @closed="onClosed"
    >
      <template slot="form">
        <el-row>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="商家编号" prop="BusiCode">
              <el-input
                v-model="data.BusiCode"
                placeholder="请输入商家编号"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="商家全称" prop="BusiName">
              <el-input
                v-model="data.BusiName"
                placeholder="请输入商家名称"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="商家简称" prop="BusiShortname">
              <el-input
                v-model="data.BusiShortname"
                placeholder="请输入商家简称"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="$store.state.isMB ? 24 : 12">
            <el-form-item label="注册日期" prop="RegTime">
              <el-date-picker
                type="datetime"
                v-model.trim="data.RegTime"
                placeholder="请选择日期"
                style="width: 100%"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="登录账号" prop="RegUser">
              <el-input
                v-model="data.RegUser"
                placeholder="请输入登录账号"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item
              label="登录密码"
              prop="RegPwd"
              :rules="isEdit ? null : pwdRules.RegPwd"
            >
              <el-input
                show-password
                v-model="data.RegPwd"
                :placeholder="isEdit ? '如无需改动可不填' : '请输入登录密码'"
                type="password"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="统一社会信用代码" prop="UnifyCode">
              <el-input
                v-model="data.UnifyCode"
                placeholder="请输入统一社会信用代码"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="法人代表" prop="LegalName">
              <el-input
                v-model="data.LegalName"
                placeholder="请输入法人代表"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="联系人" prop="ContactName">
              <el-input
                v-model="data.ContactName"
                placeholder="请输入联系人"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="联系电话" prop="ContactPhone">
              <el-input
                v-model="data.ContactPhone"
                placeholder="请输入联系电话"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="商家地址" prop="ContactAddress">
              <el-input
                v-model="data.ContactAddress"
                placeholder="请输入商家地址"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="平台分佣(%)" prop="Rate">
              <el-input
                v-model="data.Rate"
                placeholder="请输入平台分佣"
                clearable
                type="number"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="主营分类" prop="BusiTypes">
              <el-select multiple v-model="data.BusiTypes">
                <el-option
                  v-for="item in types"
                  :key="item.RecordId"
                  :label="item.TypeName"
                  :value="item.RecordId"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="主营商品" prop="MainProducts">
              <el-input
                v-model="data.MainProducts"
                placeholder="请输入主营商品"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item
              :label="isMB ? '' : '营业执照'"
              :label-width="isMB ? '0' : ''"
              prop="LicensePhoto"
            >
              <el-divider v-if="isMB">营业执照</el-divider>
              <single-pic-upload
                v-model="data.LicensePhoto"
                type="LicensePhoto"
                :uploadUrl="uploadUrl"
              ></single-pic-upload>
              <span style="color:red">最佳宽长比例1：3</span>
            </el-form-item>
          </el-col>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item
              :label="isMB ? '' : '客服二维码'"
              :label-width="isMB ? '0' : ''"
              prop="QrCode"
            >
              <el-divider v-if="isMB">客服二维码</el-divider>
              <single-pic-upload
                v-model="data.QrCode"
                type="QrCode"
                :uploadUrl="uploadUrl"
              ></single-pic-upload>
              <span style="color:red">最佳宽长比例1：1</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item
              :label="isMB ? '' : '商家头像'"
              :label-width="isMB ? '0' : ''"
              prop="BusiPhoto"
            >
              <el-divider v-if="isMB">商家头像</el-divider>
              <single-pic-upload
                v-model="data.BusiPhoto"
                type="BusiPhoto"
                :uploadUrl="uploadUrl"
              ></single-pic-upload>
              <span style="color:red">最佳宽长比例1：1</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="简介" prop="BusiInfo">
              <el-input
                type="textarea"
                placeholder="请输入内容"
                v-model="data.BusiInfo"
                maxlength="300"
                show-word-limit
                rows="5"
              >
              </el-input
            ></el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <!-- <el-col :span="isMB ? 24 : 12">
            <el-form-item label="序号" prop="OrderId">
              <el-input-number v-model="data.OrderId" :min="0" />
            </el-form-item>
          </el-col> -->

          <el-col :span="isMB ? 24 : 12" v-if="data.RecordId">
            <el-form-item label="数据来源">
              {{ data.DataSource == 0 ? "后台添加" : "小程序申请" }}
            </el-form-item>
          </el-col>
        </el-row>
      </template>
      <template slot="footer">
        <el-button
          type="primary"
          @click="toSave(0)"
          v-if="$permission.canEdit()&&loginInfo.UserType == 0 "
          >保 存</el-button
        >

        <el-button @click="close">关闭</el-button>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import singlePicUpload from "@/components/common/photo/singleUpload";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    singlePicUpload,
  },

  computed: {},
  data() {
    return {
      data: {
        RecordId: 0,
        OrderId: 0,
        BusiName: "",
        BusiShortname: "",
        BusiCode: "",

        RegTime: "",
        UnifyCode: "",
        LegalName: "",

        ContactName: "",
        ContactPhone: "",
        ContactAddress: "",
        LicensePhoto: "",

        DataSource: 0,
        Rate: null,
        RegUser: "",
        RegPwd: "",
        CheckState: 2,
        QrCode: "",
        BusiInfo: "",
        BusiPhoto: "",
        BusiType: "",
        BusiTypes: [],
        MainProducts: "",
      },
      saveState: 0,
      isEdit: false,
      api: require("@/api/shop/business").default,
      type_api: require("@/api/goods/typeplatform").default,
      isMB: this.$store.state.isMB,
      rules: {
        BusiCode: [{ required: true, message: "商家编码不能为空" }],
        BusiName: [{ required: true, message: "商家全称不能为空" }],
        BusiShortname: [{ required: true, message: "商家简称不能为空" }],
        UnifyCode: [{ required: true, message: "统一社会信用代码不能为空" }],
        LegalName: [{ required: true, message: "法人代表不能为空" }],
        ContactName: [{ required: true, message: "联系人不能为空" }],
        ContactAddress: [{ required: true, message: "商家地址不能为空" }],
        LicensePhoto: [{ required: true, message: "营业执照不能为空" }],
        QrCode: [{ required: true, message: "客服二维码不能为空" }],
        BusiInfo: [{ required: true, message: "简介不能为空" }],
        BusiPhoto: [{ required: true, message: "商家头像不能为空" }],
        BusiTypes: [{ required: true, message: "主营分类不能为空" }],
        RegTime: [{ required: true, message: "注册时间不能为空" }],
        MainProducts: [{ required: true, message: "主营商品不能为空" }],
        RegUser: [{ required: true, message: "登录账号不能为空" }],
        ContactPhone: [
          {
            required: true,
            validator: this.$commonJs.validateRules.validPhone2,
          },
        ],
        // OrderId: [{ required: true, message: "序号不能为空" }],
      },
      pwdRules: {
        RegPwd: [
          { required: true, message: "登录密码不能为空" },
          // { validator: this.$commonJs.validateRules.validPwd },
        ],
      },
      uploadUrl: "/api/Common/UploadPicture",
      types: [],
      
      loginInfo: JSON.parse(localStorage.getItem("loginInfo")),
    };
  },
  mounted() {
    this.type_api.list({ TypeLevel: 1 }).then((res) => {
      if (res.Code == 0) {
        this.types = res.Data;
      }
    });
  },
  methods: {
    onCreateOpened(row) {
      this.isEdit = false;
      this.api.getMaxOrderId().then((res) => {
        if (res.Code == 0) this.data.OrderId = res.Data;
      });
      this.api.getBusinessCode().then((res) => {
        if (res.Code == 0) this.data.BusiCode = res.Data;
      });
    },
    onEditOpened(data) {
      this.isEdit = true;
      this.data.RegPwd = "";
      if (data.BusiType) {
        var typeids = data.BusiType.split(",");
        this.data.BusiTypes=[];
        typeids.forEach((element) => {
          if(!this.data.BusiTypes.find(x=>x==element)){

            this.data.BusiTypes.push(Number(element));
          }
        });
      }
      console.log(this.data, "aa");
    },
    toSave(t) {
      this.saveState = t;
      if (this.data.BusiTypes) {
        this.data.BusiType = this.data.BusiTypes.join(",");
      }
      this.save();
    },
    onBeforeSave() {},
    onClosed() {},
  },
};
</script>
